import BusinessContractList from './BusinessContractList';
import BusinessContractEdit from './BusinessContractEdit';

const businessContracts = {
	list: BusinessContractList,
	edit: BusinessContractEdit
};

export default businessContracts;
